import { FC, ReactElement } from "react"
import icons from "@/assets/icons"
import { Icon, IconColor } from "@/components/shared/Icon"
import { AlertVitals } from "@/types/alert"

export interface VitalConfig {
   highKey: keyof AlertVitals
   lowKey: keyof AlertVitals
   vitalName: keyof typeof icons
   vitalKey: string
}

export interface VitalIconsProps {
   vitals?: AlertVitals
   typefaceIconColor: IconColor
   vitalConfigs: readonly VitalConfig[]
}

const makeVitalIcons = (
   vitalKey: string,
   vitalName: keyof typeof icons,
   thresholdDirection: "upperThreshold" | "lowerThreshold",
   typefaceIconColor: IconColor
) => [
   <Icon
      key={vitalKey}
      name={vitalName}
      color={typefaceIconColor}
      size="24"
   />,
   <Icon
      key={`${vitalKey}${thresholdDirection === "upperThreshold" ? "Up" : "Down"}`}
      name={thresholdDirection}
      color={typefaceIconColor}
      size="24"
   />,
]

const VitalIcons: FC<VitalIconsProps> = ({
   vitals,
   typefaceIconColor,
   vitalConfigs,
}) => {
   const vitalIcons: ReactElement[] = []

   vitalConfigs.forEach(({ highKey, lowKey, vitalName, vitalKey }) => {
      if (vitals?.[highKey]) {
         vitalIcons.push(
            ...makeVitalIcons(
               vitalKey,
               vitalName,
               "upperThreshold",
               typefaceIconColor
            )
         )
      } else if (vitals?.[lowKey]) {
         vitalIcons.push(
            ...makeVitalIcons(
               vitalKey,
               vitalName,
               "lowerThreshold",
               typefaceIconColor
            )
         )
      }
   })

   return vitalIcons.length > 0 ? <>{vitalIcons}</> : null
}

export default VitalIcons
